import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=3d878c7d&scoped=true&"
import script from "./ErrorBox.vue?vue&type=script&lang=ts&"
export * from "./ErrorBox.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=3d878c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d878c7d",
  null
  
)

export default component.exports